import React from 'react';
import {useSelector} from "react-redux";
import Dined from "../elements/Dined";

const withAccess = (WrappedComponent) => {
    const EnhancedComponent = (props) => {
        const dined = useSelector((state) => state.access.dined);

        return  dined ? <Dined/> : <WrappedComponent {...props} />;
    }

    return EnhancedComponent;
}

export default withAccess;